export const PROFILE_TONES = [
  '#f8edf8',
  '#edeef8',
  '#f8edf1',
  '#f8eded',
  '#f8f0ed',
  '#fff7ea',
  '#fffcea',
  '#f5ffea',
  '#e4f4ec',
  '#ebfcff',
  '#ebf5ff',
] as const

export function profileTone(orgId: string): string {
  let h = 0
  for (let i = 0; i < orgId.length; i += 1) h = (h * 31 + orgId.charCodeAt(i)) % 100000
  return PROFILE_TONES[h % PROFILE_TONES.length] ?? PROFILE_TONES[0]
}
